/**
 * Lifetime (in days) of an anonymized public talent link, mirrored from the
 * backend's TalentSelectionService.DefaultLinkLifetime (90 days). Used in the
 * prospection wizard copy and the "save selection" pop-in. Keep in sync with the
 * backend if the TTL ever changes.
 */
export const PUBLIC_LINK_TTL_DAYS = 90;
